/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeBotProfileResponse,
  ApiEnvelopeNameAvailabilityResponse,
  ApiEnvelopeNameChangeInfoResponse,
  BotProfileCheckNameAvailableParams,
  BotProfileSetSkinFromFileBody,
  SetCapeRequest,
  SetNameRequest,
  SetSkinUrlRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type botProfileGetProfileResponse200 = {
  data: ApiEnvelopeBotProfileResponse
  status: 200
}

export type botProfileGetProfileResponse400 = {
  data: ApiEnvelopeBotProfileResponse
  status: 400
}

export type botProfileGetProfileResponse401 = {
  data: ApiEnvelopeBotProfileResponse
  status: 401
}

export type botProfileGetProfileResponse403 = {
  data: ApiEnvelopeBotProfileResponse
  status: 403
}

export type botProfileGetProfileResponse404 = {
  data: ApiEnvelopeBotProfileResponse
  status: 404
}

export type botProfileGetProfileResponseSuccess = (botProfileGetProfileResponse200) & {
  headers: Headers;
};
export type botProfileGetProfileResponseError = (botProfileGetProfileResponse400 | botProfileGetProfileResponse401 | botProfileGetProfileResponse403 | botProfileGetProfileResponse404) & {
  headers: Headers;
};

export type botProfileGetProfileResponse = (botProfileGetProfileResponseSuccess | botProfileGetProfileResponseError)

export const getBotProfileGetProfileUrl = (id: string,) => {




  return `/api/botregistry/${id}/profile`
}

export const useBotProfileGetProfileHook = (): (id: string, options?: RequestInit) => Promise<botProfileGetProfileResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getBotProfileGetProfileUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botProfileGetNameCooldownResponse200 = {
  data: ApiEnvelopeNameChangeInfoResponse
  status: 200
}

export type botProfileGetNameCooldownResponse400 = {
  data: ApiEnvelopeNameChangeInfoResponse
  status: 400
}

export type botProfileGetNameCooldownResponse401 = {
  data: ApiEnvelopeNameChangeInfoResponse
  status: 401
}

export type botProfileGetNameCooldownResponse403 = {
  data: ApiEnvelopeNameChangeInfoResponse
  status: 403
}

export type botProfileGetNameCooldownResponse404 = {
  data: ApiEnvelopeNameChangeInfoResponse
  status: 404
}

export type botProfileGetNameCooldownResponseSuccess = (botProfileGetNameCooldownResponse200) & {
  headers: Headers;
};
export type botProfileGetNameCooldownResponseError = (botProfileGetNameCooldownResponse400 | botProfileGetNameCooldownResponse401 | botProfileGetNameCooldownResponse403 | botProfileGetNameCooldownResponse404) & {
  headers: Headers;
};

export type botProfileGetNameCooldownResponse = (botProfileGetNameCooldownResponseSuccess | botProfileGetNameCooldownResponseError)

export const getBotProfileGetNameCooldownUrl = (id: string,) => {




  return `/api/botregistry/${id}/profile/name-cooldown`
}

export const useBotProfileGetNameCooldownHook = (): (id: string, options?: RequestInit) => Promise<botProfileGetNameCooldownResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getBotProfileGetNameCooldownUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botProfileCheckNameAvailableResponse200 = {
  data: ApiEnvelopeNameAvailabilityResponse
  status: 200
}

export type botProfileCheckNameAvailableResponse400 = {
  data: ApiEnvelopeNameAvailabilityResponse
  status: 400
}

export type botProfileCheckNameAvailableResponse401 = {
  data: ApiEnvelopeNameAvailabilityResponse
  status: 401
}

export type botProfileCheckNameAvailableResponse403 = {
  data: ApiEnvelopeNameAvailabilityResponse
  status: 403
}

export type botProfileCheckNameAvailableResponse404 = {
  data: ApiEnvelopeNameAvailabilityResponse
  status: 404
}

export type botProfileCheckNameAvailableResponseSuccess = (botProfileCheckNameAvailableResponse200) & {
  headers: Headers;
};
export type botProfileCheckNameAvailableResponseError = (botProfileCheckNameAvailableResponse400 | botProfileCheckNameAvailableResponse401 | botProfileCheckNameAvailableResponse403 | botProfileCheckNameAvailableResponse404) & {
  headers: Headers;
};

export type botProfileCheckNameAvailableResponse = (botProfileCheckNameAvailableResponseSuccess | botProfileCheckNameAvailableResponseError)

export const getBotProfileCheckNameAvailableUrl = (id: string,
    params?: BotProfileCheckNameAvailableParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/botregistry/${id}/profile/name-available?${stringifiedParams}` : `/api/botregistry/${id}/profile/name-available`
}

export const useBotProfileCheckNameAvailableHook = (): (id: string,
    params?: BotProfileCheckNameAvailableParams, options?: RequestInit) => Promise<botProfileCheckNameAvailableResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    params?: BotProfileCheckNameAvailableParams, options?: RequestInit) => {

        return customFetcher(getBotProfileCheckNameAvailableUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botProfileSetSkinFromUrlResponse200 = {
  data: ApiEnvelopeBotProfileResponse
  status: 200
}

export type botProfileSetSkinFromUrlResponse400 = {
  data: ApiEnvelopeBotProfileResponse
  status: 400
}

export type botProfileSetSkinFromUrlResponse401 = {
  data: ApiEnvelopeBotProfileResponse
  status: 401
}

export type botProfileSetSkinFromUrlResponse403 = {
  data: ApiEnvelopeBotProfileResponse
  status: 403
}

export type botProfileSetSkinFromUrlResponse404 = {
  data: ApiEnvelopeBotProfileResponse
  status: 404
}

export type botProfileSetSkinFromUrlResponseSuccess = (botProfileSetSkinFromUrlResponse200) & {
  headers: Headers;
};
export type botProfileSetSkinFromUrlResponseError = (botProfileSetSkinFromUrlResponse400 | botProfileSetSkinFromUrlResponse401 | botProfileSetSkinFromUrlResponse403 | botProfileSetSkinFromUrlResponse404) & {
  headers: Headers;
};

export type botProfileSetSkinFromUrlResponse = (botProfileSetSkinFromUrlResponseSuccess | botProfileSetSkinFromUrlResponseError)

export const getBotProfileSetSkinFromUrlUrl = (id: string,) => {




  return `/api/botregistry/${id}/profile/skin/url`
}

export const useBotProfileSetSkinFromUrlHook = (): (id: string,
    setSkinUrlRequest?: SetSkinUrlRequest, options?: RequestInit) => Promise<botProfileSetSkinFromUrlResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    setSkinUrlRequest?: SetSkinUrlRequest, options?: RequestInit) => {

        return customFetcher(getBotProfileSetSkinFromUrlUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setSkinUrlRequest)
  }
);
      }
  }


export type botProfileSetSkinFromFileResponse200 = {
  data: ApiEnvelopeBotProfileResponse
  status: 200
}

export type botProfileSetSkinFromFileResponse400 = {
  data: ApiEnvelopeBotProfileResponse
  status: 400
}

export type botProfileSetSkinFromFileResponse401 = {
  data: ApiEnvelopeBotProfileResponse
  status: 401
}

export type botProfileSetSkinFromFileResponse403 = {
  data: ApiEnvelopeBotProfileResponse
  status: 403
}

export type botProfileSetSkinFromFileResponse404 = {
  data: ApiEnvelopeBotProfileResponse
  status: 404
}

export type botProfileSetSkinFromFileResponseSuccess = (botProfileSetSkinFromFileResponse200) & {
  headers: Headers;
};
export type botProfileSetSkinFromFileResponseError = (botProfileSetSkinFromFileResponse400 | botProfileSetSkinFromFileResponse401 | botProfileSetSkinFromFileResponse403 | botProfileSetSkinFromFileResponse404) & {
  headers: Headers;
};

export type botProfileSetSkinFromFileResponse = (botProfileSetSkinFromFileResponseSuccess | botProfileSetSkinFromFileResponseError)

export const getBotProfileSetSkinFromFileUrl = (id: string,) => {




  return `/api/botregistry/${id}/profile/skin/file`
}

export const useBotProfileSetSkinFromFileHook = (): (id: string,
    botProfileSetSkinFromFileBody?: BotProfileSetSkinFromFileBody, options?: RequestInit) => Promise<botProfileSetSkinFromFileResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    botProfileSetSkinFromFileBody?: BotProfileSetSkinFromFileBody, options?: RequestInit) => {
        const formData = new FormData();
if(botProfileSetSkinFromFileBody?.variant !== undefined) {
 formData.append(`variant`, botProfileSetSkinFromFileBody.variant);
 }
if(botProfileSetSkinFromFileBody?.file !== undefined) {
 formData.append(`file`, botProfileSetSkinFromFileBody.file);
 }

        return customFetcher(getBotProfileSetSkinFromFileUrl(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);
      }
  }


export type botProfileResetSkinResponse200 = {
  data: ApiEnvelopeBotProfileResponse
  status: 200
}

export type botProfileResetSkinResponse400 = {
  data: ApiEnvelopeBotProfileResponse
  status: 400
}

export type botProfileResetSkinResponse401 = {
  data: ApiEnvelopeBotProfileResponse
  status: 401
}

export type botProfileResetSkinResponse403 = {
  data: ApiEnvelopeBotProfileResponse
  status: 403
}

export type botProfileResetSkinResponse404 = {
  data: ApiEnvelopeBotProfileResponse
  status: 404
}

export type botProfileResetSkinResponseSuccess = (botProfileResetSkinResponse200) & {
  headers: Headers;
};
export type botProfileResetSkinResponseError = (botProfileResetSkinResponse400 | botProfileResetSkinResponse401 | botProfileResetSkinResponse403 | botProfileResetSkinResponse404) & {
  headers: Headers;
};

export type botProfileResetSkinResponse = (botProfileResetSkinResponseSuccess | botProfileResetSkinResponseError)

export const getBotProfileResetSkinUrl = (id: string,) => {




  return `/api/botregistry/${id}/profile/skin`
}

export const useBotProfileResetSkinHook = (): (id: string, options?: RequestInit) => Promise<botProfileResetSkinResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getBotProfileResetSkinUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type botProfileSetCapeResponse200 = {
  data: ApiEnvelopeBotProfileResponse
  status: 200
}

export type botProfileSetCapeResponse400 = {
  data: ApiEnvelopeBotProfileResponse
  status: 400
}

export type botProfileSetCapeResponse401 = {
  data: ApiEnvelopeBotProfileResponse
  status: 401
}

export type botProfileSetCapeResponse403 = {
  data: ApiEnvelopeBotProfileResponse
  status: 403
}

export type botProfileSetCapeResponse404 = {
  data: ApiEnvelopeBotProfileResponse
  status: 404
}

export type botProfileSetCapeResponseSuccess = (botProfileSetCapeResponse200) & {
  headers: Headers;
};
export type botProfileSetCapeResponseError = (botProfileSetCapeResponse400 | botProfileSetCapeResponse401 | botProfileSetCapeResponse403 | botProfileSetCapeResponse404) & {
  headers: Headers;
};

export type botProfileSetCapeResponse = (botProfileSetCapeResponseSuccess | botProfileSetCapeResponseError)

export const getBotProfileSetCapeUrl = (id: string,) => {




  return `/api/botregistry/${id}/profile/cape`
}

export const useBotProfileSetCapeHook = (): (id: string,
    setCapeRequest?: SetCapeRequest, options?: RequestInit) => Promise<botProfileSetCapeResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    setCapeRequest?: SetCapeRequest, options?: RequestInit) => {

        return customFetcher(getBotProfileSetCapeUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setCapeRequest)
  }
);
      }
  }


export type botProfileHideCapeResponse200 = {
  data: ApiEnvelopeBotProfileResponse
  status: 200
}

export type botProfileHideCapeResponse400 = {
  data: ApiEnvelopeBotProfileResponse
  status: 400
}

export type botProfileHideCapeResponse401 = {
  data: ApiEnvelopeBotProfileResponse
  status: 401
}

export type botProfileHideCapeResponse403 = {
  data: ApiEnvelopeBotProfileResponse
  status: 403
}

export type botProfileHideCapeResponse404 = {
  data: ApiEnvelopeBotProfileResponse
  status: 404
}

export type botProfileHideCapeResponseSuccess = (botProfileHideCapeResponse200) & {
  headers: Headers;
};
export type botProfileHideCapeResponseError = (botProfileHideCapeResponse400 | botProfileHideCapeResponse401 | botProfileHideCapeResponse403 | botProfileHideCapeResponse404) & {
  headers: Headers;
};

export type botProfileHideCapeResponse = (botProfileHideCapeResponseSuccess | botProfileHideCapeResponseError)

export const getBotProfileHideCapeUrl = (id: string,) => {




  return `/api/botregistry/${id}/profile/cape`
}

export const useBotProfileHideCapeHook = (): (id: string, options?: RequestInit) => Promise<botProfileHideCapeResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getBotProfileHideCapeUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type botProfileChangeNameResponse200 = {
  data: ApiEnvelopeBotProfileResponse
  status: 200
}

export type botProfileChangeNameResponse400 = {
  data: ApiEnvelopeBotProfileResponse
  status: 400
}

export type botProfileChangeNameResponse401 = {
  data: ApiEnvelopeBotProfileResponse
  status: 401
}

export type botProfileChangeNameResponse403 = {
  data: ApiEnvelopeBotProfileResponse
  status: 403
}

export type botProfileChangeNameResponse404 = {
  data: ApiEnvelopeBotProfileResponse
  status: 404
}

export type botProfileChangeNameResponseSuccess = (botProfileChangeNameResponse200) & {
  headers: Headers;
};
export type botProfileChangeNameResponseError = (botProfileChangeNameResponse400 | botProfileChangeNameResponse401 | botProfileChangeNameResponse403 | botProfileChangeNameResponse404) & {
  headers: Headers;
};

export type botProfileChangeNameResponse = (botProfileChangeNameResponseSuccess | botProfileChangeNameResponseError)

export const getBotProfileChangeNameUrl = (id: string,) => {




  return `/api/botregistry/${id}/profile/name`
}

export const useBotProfileChangeNameHook = (): (id: string,
    setNameRequest?: SetNameRequest, options?: RequestInit) => Promise<botProfileChangeNameResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    setNameRequest?: SetNameRequest, options?: RequestInit) => {

        return customFetcher(getBotProfileChangeNameUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setNameRequest)
  }
);
      }
  }


